import { render, staticRenderFns } from "./selectBasePowder.vue?vue&type=template&id=078d66b1&"
import script from "./selectBasePowder.vue?vue&type=script&lang=js&"
export * from "./selectBasePowder.vue?vue&type=script&lang=js&"
import style0 from "./selectBasePowder.vue?vue&type=style&index=0&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports